import { actionsFactory, props } from '@ngneat/effects';
import { RoutingProfileStats } from '@tmx/data-access';

export interface OnboardingTourStats {
  assetHasLicense: boolean;
  hasAsset: boolean;
  hasMapset: boolean;
  hasVehicle: boolean | null;
  hasVehicleGroup: boolean | null;
}

const onboardingTourActions = actionsFactory('onboarding-tour');

export const initializeOnboardingTourChecklist = onboardingTourActions.create(
  'Initialize Onboarding Tour Checklist'
);

export const onboardingTourChecklistInitialized = onboardingTourActions.create(
  'Onboarding Tour Checklist Initialized'
);

export const setOnboardingInitialStats = onboardingTourActions.create(
  'Set Onboarding Tour Initial Stats',
  props<{
    accountStats: OnboardingTourStats;
    routingProfileStats: RoutingProfileStats;
  }>()
);

export const completeItineraryItem = onboardingTourActions.create(
  'Complete Itinerary By Name',
  props<{ itineraryName: string }>()
);
